export default {
  metaTitle: '对话消息',
  pageTitle: '客户对话管理',
  region: '国别',
  placeholder1: '用户ID',
  column1: '用户ID',
  column2: '对话ID',
  column3: '用户昵称',
  column4: '创建时间',
  column5: '更新时间',
  column6: '最后跟进人',
  column7: '操作',
  chat: '聊天',
  message: '客户即时聊天'
}
